import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';

export class BinaryHistoryItem {
  id: number;

  @Expose({ name: 'pv_added' })
  pvAdded: string;

  @Expose({ name: 'pv_deducted_left' })
  pvDeductedLeft: string;

  @Expose({ name: 'pv_deducted_right' })
  pvDeductedRight: string;

  @Expose({ name: 'total_left' })
  leftPoints: string;

  @Expose({ name: 'total_right' })
  rightPoints: string;

  @Expose({ name: 'carry_left' })
  leftCarry: string;

  @Expose({ name: 'carry_right' })
  rightCarry: string;

  leg?: string;

  @Expose({ name: 'bonus_generated' })
  bonusGenerated?: string;

  @Expose({ name: 'bonus_to_pay' })
  bonusToPay?: string;

  @Expose({ name: 'capping_limit' })
  cappingLimit?: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'from_username' })
  fromUser?: string;

  constructor(
    id: number,
    pvAdded: string,
    pvDeductedLeft: string,
    pvDeductedRight: string,
    leftPoints: string,
    rightPoints: string,
    leftCarry: string,
    rightCarry: string,
    leg: string,
    dateCreated: Date,
    fromUser: string,
    bonusGenerated?: string,
    bonusToPay?: string,
    cappingLimit?: string
  ) {
    this.id = id;
    this.pvAdded = pvAdded;
    this.pvDeductedLeft = pvDeductedLeft;
    this.pvDeductedRight = pvDeductedRight;
    this.leftPoints = leftPoints;
    this.rightPoints = rightPoints;
    this.leftCarry = leftCarry;
    this.rightCarry = rightCarry;
    this.leg = leg;
    this.bonusGenerated = bonusGenerated;
    this.bonusToPay = bonusToPay;
    this.cappingLimit = cappingLimit;
    this.dateCreated = dateCreated;
    this.fromUser = fromUser;
  }

  get isDeducted(): boolean {
    return this.leg === undefined;
  }

  get pvDeductedMax(): string {
    const maxLeft = Number(this.pvDeductedLeft) || 0;
    const maxRight = Number(this.pvDeductedRight) || 0;
    return maxLeft >= maxRight ? this.pvDeductedLeft : this.pvDeductedRight;
  }

  get is21Pair(): boolean {
    const left = Number(this.pvDeductedLeft) || 0;
    const right = Number(this.pvDeductedRight) || 0;
    return left !== right;
  }

  static fromJson(json: Record<string, any>): BinaryHistoryItem {
    return plainToInstance(BinaryHistoryItem, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class BinaryHistoryPaginated {
  @Type(() => BinaryHistoryItem)
  items: BinaryHistoryItem[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  constructor(items: BinaryHistoryItem[], nextPageUrl?: string) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
  }

  get cursor(): string | null {
    return this.nextPageUrl
      ? new URL(this.nextPageUrl).searchParams.get('cursor')
      : null;
  }

  static fromJson(json: Record<string, any>): BinaryHistoryPaginated {
    return plainToInstance(BinaryHistoryPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
